import { render, staticRenderFns } from "./MobilePos.vue?vue&type=template&id=f5155162&scoped=true"
import script from "./MobilePos.vue?vue&type=script&lang=js"
export * from "./MobilePos.vue?vue&type=script&lang=js"
import style0 from "./MobilePos.vue?vue&type=style&index=0&id=f5155162&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5155162",
  null
  
)

export default component.exports